import styled from "styled-components";

const EmailInput = styled.input.attrs({
  type: "email",
  pattern: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
})``;

export default EmailInput;
